import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { PDFViewer, Document } from "@react-pdf/renderer";
import { useSearchParams } from 'react-router-dom';
import axiosInstant from "../../../api";
import { ISinglePro } from "../../../components/singlePro/state";
import { SinglePage } from "./SinglePage";
import { ProExportContext } from "./helper";

interface GetParams {
  search?: string;
  limit?: number;
  headshot?: string;
  status?: string;
  profession?: string;
  subprofession?: string;
  tier?: string;
  gender?: string;
  ethnicity?: string;
  region?: string;
  state?: string;
  recency?: string;
  daterange?: Array<string>;
  ids?: string[];
}

export const ProExportPDF: React.FC = () => {
  const [pros, setPros] = React.useState<Array<ISinglePro>>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [wide, setWide] = React.useState<boolean>( true );


  React.useEffect( () => {
    const searchPros = ( searchParams.get( 'search' ) || '' );
    const statusFilter = ( searchParams.get( 'status' ) || '' );
    const headshotFilter = ( searchParams.get( 'headshot' ) || '' );
    const professionFilter = ( searchParams.get( 'profession' ) || '' );
    const subProfessionFilter = ( searchParams.get( 'subprofession' ) || '' );
    const tierFilter = ( searchParams.get( 'tier' ) ||'' );
    const genderFilter = ( searchParams.get( 'gender' ) ||'' );
    const ethnicityFilter = ( searchParams.get( 'ethnicity' ) ||'' );
    const regionFilter = ( searchParams.get( 'region' ) ||'' );
    const stateFilter = ( searchParams.get( 'state' ) ||'' );
    const recencyFilter = ( searchParams.get( 'recency' ) ||'' );
    const dateRangeFilter = ( searchParams.get( 'daterange' ) ||'' );
    const idFilter = ( ( searchParams.get( 'ids' )?.split( ',' ) || [] ) );

    const params:GetParams = { search: searchPros, limit: 12 }
    if (headshotFilter.length > 0) {
        params.headshot = headshotFilter;
    }
    if (statusFilter.length > 0) {
        params.status = statusFilter;
    }
    if (professionFilter.length > 0) {
        params.profession = professionFilter;
    }
    if( subProfessionFilter.length > 0 ) {
        params.subprofession = subProfessionFilter;
    }
    if( tierFilter.length > 0 ) {
        params.tier = tierFilter;
    }
    if( genderFilter.length > 0 ) {
        params.gender = genderFilter;
    }
    if( ethnicityFilter.length > 0 ) {
        params.ethnicity = ethnicityFilter;
    }
    if( regionFilter.length > 0 ) {
        params.region = regionFilter;
    }
    if( stateFilter.length > 0 ) {
        params.state = stateFilter;
    }
    if( recencyFilter.length > 0 ) {
        params.recency = recencyFilter;
    }
    if( dateRangeFilter.length > 0 ) {
      const daterange = dateRangeFilter.split(",").map((e) => parseInt(e, 10));
      if (daterange?.length) {
        params.daterange = [];
        daterange.forEach((date) => {
          params.daterange?.push(new Date(date).toISOString());
        });
      }
    }
    if( idFilter.length > 0 ) {
        params.ids = idFilter;
    }

    axiosInstant
      .get("/users/pros", { params })
      .then((response) => {
        const prosList = response.data.rows;
        setPros(prosList.slice(0, 12));
        setWide( prosList.length <= 4 );
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 404) {
            setPros([]);
          }
        }
      });
  }, []);

  const renderPros = (): Array<JSX.Element> => {
    const maxProsPerPage = wide ? 4 : 6;
    const totalPages = Math.ceil(pros.length / maxProsPerPage);
    const output = [] as Array<JSX.Element>;
    for (let i = 0; i < totalPages; i += 1) {
      const index = i * maxProsPerPage;
      const prosChunk = pros.slice(index, index + maxProsPerPage);
      output.push(<SinglePage pros={prosChunk} key={i} />);
    }
    return output;
  };

  return (
    <div style={{ height: "80vh" }}>
      <PDFViewer width="100%" height="100%">
        {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
        <ProExportContext.Provider value={{ wide }}>
          <Document>{renderPros()}</Document>
        </ProExportContext.Provider>
      </PDFViewer>
    </div>
  );
};
